export default {
      id: "common__geozone_circle-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__geozone_circle",
      toString: function () {
        return this.url;
      }
    }